import { BadgeBeta } from 'components/badges/badge-beta';
import { BadgeLegacy } from 'components/badges/badge-legacy';

type Props = {
  extension: Oneflow.Extension;
};

export const ExtensionLabel = ({
  extension,
}: Props) => {
  if (!extension.label) {
    return null;
  }

  if (extension.label === 'beta') {
    return <BadgeBeta />;
  }

  if (extension.label === 'legacy') {
    return <BadgeLegacy />;
  }

  return null;
};
